


import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TablePagination,
  Box
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { creditRch } from "../../store/creditRechargeSlice";
import DownloadRchLogs from "./DownloadRchLogs";


    const CreditHistoryTable = () => {
  const dispatch = useDispatch();
  const { creditRchdata = {} } = useSelector((state) => state.creditRch);
  const creditLogs = creditRchdata.data || [];

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    dispatch(creditRch());
  }, [dispatch]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer component={Paper} sx={{ marginBottom: 3, padding: 2 }}>
      <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 2,
          }}
        >
          <Typography variant="h6">Recharge History</Typography>
          <DownloadRchLogs />
        </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><strong>ID</strong></TableCell>
            <TableCell><strong>Transaction ID</strong></TableCell>
            <TableCell><strong>Added Credits</strong></TableCell>
            <TableCell><strong>Updated  Balance</strong></TableCell>
            <TableCell><strong>Date & Time</strong></TableCell>
            <TableCell><strong>Rate Per Credit</strong></TableCell>
            <TableCell><strong>type</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {creditLogs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((log) => (
            <TableRow key={log.id}>
              <TableCell>{log.id}</TableCell>
              <TableCell>{log.transaction_id}</TableCell>
              <TableCell>{log.added_credits}</TableCell>
              <TableCell>{log.updated_balance}</TableCell>
              <TableCell>{new Date(log.datetime).toLocaleDateString()}</TableCell>
              <TableCell>{log.rate_per_credit}</TableCell>
              <TableCell>{log.type_of_transaction}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 15]}
        component="div"
        count={creditLogs.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
};



export default CreditHistoryTable;
